// import dFnsSubDays from 'date-fns/subDays';
import { GQL } from '@gin-betting/core';
import { intersection, union } from 'lodash';

import { LIVE_SPORTEVENT_STATUSES } from 'app-constants';

// const {
//     utils: { format },
// } = core;

export default function getVariablesForLiveSportEvent(
    sportEventStatuses: GQL.SportEventStatus[] | null | undefined,
    marketStatuses: GQL.MarketStatus[] | null | undefined
): {
    marketStatusesForLiveSportEvent: GQL.MarketStatus[] | null | undefined;
    dateFrom?: string | undefined;
} {
    if (
        !marketStatuses ||
        !intersection(LIVE_SPORTEVENT_STATUSES, sportEventStatuses).length
    ) {
        return {
            marketStatusesForLiveSportEvent: marketStatuses,
        };
    }

    // const dateFrom = format(dFnsSubDays(new Date(), 1), 'yyyy-MM-dd');

    return {
        marketStatusesForLiveSportEvent: union(marketStatuses, [
            GQL.MarketStatus.RESULTED,
            GQL.MarketStatus.CANCELLED,
            GQL.MarketStatus.DEACTIVATED,
        ]),
        dateFrom: undefined,
    };
}
